// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_qPB","cls2":"LoswpPackPitch-cls2_XyM LoswpPackPitch-cls1_qPB"};